import { Fragment } from 'react'

import { Skeleton } from '@/components/ui'
import { cn, range } from '@/utils'
import {
  FACTS_GRID,
  GRID,
  LABEL_COLUMN,
  LANE,
  LANE_PADDING,
  LANE_ROW,
  MONTH_GAP,
  TIMELINE_COLUMN,
  TRACK_HEIGHT,
} from './mapLayout'
import { MONTHS_IN_YEAR } from './period'

// Enough lanes to read as a map without pretending to know how many accounts the project has.
const LANE_COUNT = 3

// Type, number, bank and owner, each about as wide as its real value tends to be.
const FACT_WIDTHS = ['w-16', 'w-14', 'w-36', 'w-28']

// What the map looks like before the files arrive: the account's four facts, the counts and a
// year of months per lane, all on the real lane's measurements so the accounts drop straight into
// place. The lanes sit directly in the map's scroller, like the real ones, so the first lane's rule
// matches too.
export const LoadingLanes = () =>
  range(LANE_COUNT).map((lane) => (
    <section key={`lane-${lane}`} data-loading-lane className={LANE}>
      <div className={LANE_ROW}>
        <div className={cn(LABEL_COLUMN, LANE_PADDING)}>
          <div className={cn(FACTS_GRID, 'items-center gap-y-3 pb-2')}>
            {FACT_WIDTHS.map((width) => (
              <Fragment key={width}>
                <Skeleton className="h-2.5 w-9" />
                <Skeleton className={cn('h-3.5', width)} />
              </Fragment>
            ))}
            <Skeleton className="mt-3 h-2.5 w-9" />
            <Skeleton className="mt-3 h-3.5 w-36" />
          </div>
        </div>

        <div className={cn(TIMELINE_COLUMN, LANE_PADDING)}>
          <div
            className={cn('grid', MONTH_GAP)}
            style={{
              gridTemplateColumns: GRID,
              gridTemplateRows: TRACK_HEIGHT,
            }}
          >
            <Skeleton className="h-3 w-8 self-center" />
            {range(MONTHS_IN_YEAR).map((month) => (
              <Skeleton
                key={`month-${month}`}
                className="w-full"
                style={{ height: TRACK_HEIGHT }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  ))
